module.exports = __webpack_public_path__ + "img/osk2.1368a73a.png";